import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Box,
  Button,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

const ViewProduct = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [categoryName, setCategoryName] = useState("");

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const res = await axios.get(
          `https://ecom-api.applligentdemo.com/product/getByProductId/${id}`
        );
        const data = res.data?.product || res.data;
        setProduct(data);

        if (data.category && typeof data.category === "string") {
          const catRes = await axios.get(
            "https://ecom-api.applligentdemo.com/category/getCategory"
          );
          const list = catRes.data.categories || catRes.data;
          const matched = list.find((c) => c._id === data.category);
          if (matched) setCategoryName(matched.name);
        } else if (typeof data.category === "object") {
          setCategoryName(data.category.name);
        }
      } catch (err) {
        console.error("Error fetching product:", err);
      }
    };
    fetchProduct();
  }, [id]);

  if (!product) return <Typography>Loading...</Typography>;

  return (
    <Container maxWidth="md" sx={{ mt: 5 }}>
       <Button variant="text" onClick={() => navigate(-1)}>
              ← Back
            </Button>
      <Card
        sx={{
          display: "flex",
          borderRadius: 4,
          overflow: "hidden",
          minHeight: 450,
          boxShadow: 3,
        }}
      >
        {/* Left - Image */}
        <Box
          sx={{
            width: "40%",
            backgroundImage: `url(${product.image?.[0]})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        ></Box>

        {/* Right - Details */}
        <CardContent sx={{ flex: 1, p: 4, background: "#fff" }}>
          <Typography variant="h4" sx={{ mb: 2, fontWeight: 600 }}>
            {product.name}
          </Typography>

          <Typography variant="body1" sx={{ mb: 2, color: "gray" }}>
            {product.description}
          </Typography>

          <Grid container spacing={6}>
            <Grid item xs={2}>
              <Typography fontWeight={600}>Price:</Typography>
              <Typography>₹{product.price}</Typography>
            </Grid><br/>
            <Grid item xs={6}>
              <Typography fontWeight={600}>Stock:</Typography>
              <Typography>{product.stock}</Typography>
            </Grid><br/>
            <Grid item xs={6}>
              <Typography fontWeight={600}>Category:</Typography>
              <Typography>{categoryName || "N/A"}</Typography>
            </Grid><br/>
            <Grid item xs={6}>
              <Typography fontWeight={600}>Avg Rating:</Typography>
              <Typography>{product.averageRating}</Typography>
            </Grid><br/>
            <Grid item xs={6}>
              <Typography fontWeight={600}>Rating Count:</Typography>
              <Typography>{product.ratingCount}</Typography>
            </Grid><br/>
          </Grid>
        </CardContent>
      </Card>
    </Container>
  );
};

export default ViewProduct;
